// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1TneQy9t50v9g-TLSchoan"};